// libs
import styled from 'styled-components'
// static
import MaterialLockIcon from '@mui/icons-material/LockOutlined'

const LockIcon = styled(MaterialLockIcon)`
  && {
    margin-left: 8px;
  }
`

export default LockIcon
